


















import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {

  }
})
export default class DYHead extends Vue {
  private download() {
    location.href = 'https://wx.diyiedu.com/installapp';
  }
}
